// extracted by mini-css-extract-plugin
export default {"activateView":"styles_activateView__Wiiht"};